var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEdit = function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1874 2.75C15.9582 2.75 15.7199 2.84167 15.5457 3.01583L13.8682 4.69333L17.3057 8.13083L18.9832 6.45333C19.3407 6.09583 19.3407 5.51833 18.9832 5.16083L16.8382 3.01583C16.6549 2.8325 16.4257 2.75 16.1874 2.75ZM12.8874 8.26837L13.7307 9.11171L5.42569 17.4167H4.58236V16.5734L12.8874 8.26837ZM2.74902 15.8125L12.8874 5.67413L16.3249 9.11163L6.18652 19.25H2.74902V15.8125Z"
  })));
};
export default SvgIconEdit;